import { parseServerTimestamp } from './dateService';

// How long the "AI is typing" indicator stays up after Trigger Inbound before we give up. The reply
// is generated in the background: the message accumulation window (15s by default) plus the N2 call.
export const TRIGGERED_AI_REPLY_TIMEOUT_MS = 90 * 1000;

// Tolerance for the browser's clock running ahead of the server's.
const CLOCK_SKEW_MS = 2 * 60 * 1000;

const toMillis = (timestamp) => {
  const date = parseServerTimestamp(timestamp);
  return date ? date.getTime() : null;
};

/**
 * True once the conversation shows the AI's reply to the customer message that Trigger Inbound
 * created at (roughly) `triggeredAt` (a Date.now() value). `messages` must be in display order.
 *
 * Older history doesn't count - the lead may already exist, or a cached copy of its conversation
 * may be stale. We first find the triggered customer message (the latest customer message no older
 * than `triggeredAt` minus a clock-skew margin); only an AI message after it ends the wait.
 */
export const hasAiReplySince = (messages, triggeredAt) => {
  const list = (messages || []).filter((message) => !message.isOptimistic);
  const earliest = triggeredAt - CLOCK_SKEW_MS;

  let triggeredIndex = -1;
  list.forEach((message, index) => {
    if (message.sender !== 'user') return;
    const time = toMillis(message.timestamp);
    if (time !== null && time >= earliest) triggeredIndex = index;
  });
  if (triggeredIndex === -1) return false;

  return list
    .slice(triggeredIndex + 1)
    .some((message) => message.sender !== 'user' && message.sender !== 'handoff');
};
